import React from 'react';
import { Link } from 'react-router-dom';
import { urlManager } from '../../../Utils/URL/URLManager';
import AdminLayout from '../../../Components/PageLayouts/AdminLayout/AdminLayout';
import { Container, Grid, Paper } from '@mui/material';

interface Props {}

const AdminUsersPage: React.FC<Props> = () => (
  <AdminLayout>
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        <Grid container item spacing={3} xs={12} md={12} lg={12}>
          <Grid item xs={12} sm={6} md={3}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 150,
              }}
            >
              100
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 150,
              }}
            >
              100
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 150,
              }}
            >
              100
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 150,
              }}
            >
              100
            </Paper>
          </Grid>
        </Grid>
        <Grid item xs={12} md={12} lg={12}>
          <Paper
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              height: 240,
            }}
          >
            <h4>Admin Users Page</h4>
            <div>
              <div>
                <Link to={urlManager.home()}>Home</Link>
              </div>
              <div>
                <Link to={urlManager.admin().root()}>Admin Panel</Link>
              </div>
            </div>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  </AdminLayout>
);

export default AdminUsersPage;
